import Surveys from './Surveys';
import './Surveys.scss';

export default Surveys;
